var _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftDashedSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 32,
    viewBox: "0 0 13 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 17.8551,
    y2: -1,
    transform: "matrix(-0.580466 0.814285 -0.808034 -0.589136 10.9448 0.875)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.5 5.5"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -1,
    x2: 17.8551,
    y2: -1,
    transform: "matrix(-0.580466 -0.814285 -0.808034 0.589136 11 31.125)",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeDasharray: "5.5 5.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftDashedSmall);
export default __webpack_public_path__ + "static/media/arrow_left_dashed_small.4b7b6788a09d5e6304e7fa8617155aaa.svg";
export { ForwardRef as ReactComponent };